module.exports = __webpack_public_path__ + "img/csharp_red.679cb16a.png";